// MODÜL 16: HAVACILIK TERİMLERİ

const cabinCrewContentsM16 = {
  // ==================== ICAO ALFABE ====================
  'CM-M16-U1-L1': {
    lesson_id: 'CM-M16-U1-L1',
    title: 'Fonetik Alfabe',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'ICAO Fonetik Alfabe',
      paragraphs: [
        'NATO/ICAO Fonetik Alfabe: Uluslararası havacılıkta standart iletişim.',
        'Neden Gerekli?: Telsizde harfler karışabilir. "B" ve "D" gibi. Net iletişim şart.',
        'A-Alpha, B-Bravo, C-Charlie, D-Delta, E-Echo, F-Foxtrot, G-Golf, H-Hotel',
        'I-India, J-Juliet, K-Kilo, L-Lima, M-Mike, N-November, O-Oscar, P-Papa',
        'Q-Quebec, R-Romeo, S-Sierra, T-Tango, U-Uniform, V-Victor, W-Whiskey, X-X-ray, Y-Yankee, Z-Zulu'
      ],
      keyPoints: [
        'NATO/ICAO standardı',
        'A = Alpha',
        'B = Bravo',
        'Z = Zulu'
      ]
    }
  },
  'CM-M16-U1-L2': {
    lesson_id: 'CM-M16-U1-L2',
    title: 'Alfabe Pratiği',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Fonetik Alfabe Kullanımı',
      paragraphs: [
        'THY: Tango-Hotel-Yankee',
        'IST: India-Sierra-Tango (İstanbul Havalimanı)',
        'SAW: Sierra-Alpha-Whiskey (Sabiha Gökçen)',
        'AYT: Alpha-Yankee-Tango (Antalya)',
        'Uçuş No Örnek: TK1234 = Tango-Kilo-One-Two-Three-Four'
      ],
      keyPoints: [
        'THY = Tango-Hotel-Yankee',
        'IST = India-Sierra-Tango',
        'Rakamlar tek tek söylenir',
        'Pratik yaparak öğrenilir'
      ]
    }
  },
  'CM-M16-U1-L3': {
    lesson_id: 'CM-M16-U1-L3',
    title: 'Alfabe Eşleştirme',
    type: 'matching',
    duration: 4,
    xp: 40,
    matching: {
      pairs: [
        { id: 1, left: 'A', right: 'Alpha' },
        { id: 2, left: 'B', right: 'Bravo' },
        { id: 3, left: 'C', right: 'Charlie' },
        { id: 4, left: 'D', right: 'Delta' },
        { id: 5, left: 'T', right: 'Tango' },
        { id: 6, left: 'Z', right: 'Zulu' }
      ]
    }
  },
  'CM-M16-U1-L4': {
    lesson_id: 'CM-M16-U1-L4',
    title: 'Alfabe Yarışı',
    type: 'timerace',
    duration: 4,
    xp: 50,
    timerace: {
      timePerQuestion: 5,
      questions: [
        { q: 'A harfi?', options: ['Alpha', 'Alfa', 'Apple', 'Able'], correct: 0 },
        { q: 'B harfi?', options: ['Beta', 'Boy', 'Bravo', 'Baker'], correct: 2 },
        { q: 'G harfi?', options: ['George', 'Golf', 'Gamma', 'Girl'], correct: 1 },
        { q: 'R harfi?', options: ['Roger', 'Romeo', 'Radio', 'Robert'], correct: 1 },
        { q: 'Z harfi?', options: ['Zero', 'Zebra', 'Zulu', 'Zone'], correct: 2 },
        { q: 'N harfi?', options: ['Nancy', 'November', 'Nine', 'Niner'], correct: 1 }
      ]
    }
  },

  // ==================== HAVAALANI KODLARI ====================
  'CM-M16-U2-L1': {
    lesson_id: 'CM-M16-U2-L1',
    title: 'IATA Kodları',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'IATA Havaalani Kodları',
      paragraphs: [
        'IATA: International Air Transport Association. 3 harfli kodlar.',
        'ICAO: International Civil Aviation Organization. 4 harfli kodlar (LTBA gibi).',
        'Türkiye IATA: IST (İstanbul), SAW (Sabiha Gökçen), ESB (Ankara), AYT (Antalya), ADB (İzmir)',
        'Avrupa: LHR (Londra Heathrow), CDG (Paris), FRA (Frankfurt), AMS (Amsterdam)',
        'Körfez: DXB (Dubai), DOH (Doha), AUH (Abu Dhabi)'
      ],
      keyPoints: [
        'IATA = 3 harf',
        'ICAO = 4 harf',
        'IST = İstanbul',
        'DXB = Dubai'
      ]
    }
  },
  'CM-M16-U2-L2': {
    lesson_id: 'CM-M16-U2-L2',
    title: 'Türkiye Havaalanları',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Türkiye IATA Kodları',
      paragraphs: [
        'IST: İstanbul Havalimanı. 2019\'da açıldı. THY ana hub.',
        'SAW: Sabiha Gökçen. Anadolu yakası. Pegasus hub.',
        'ESB: Ankara Esenboğa. Başkent havalimanı. AnadoluJet hub.',
        'AYT: Antalya. Turizm merkezi. SunExpress hub.',
        'ADB: İzmir Adnan Menderes. Ege bölgesi.',
        'TZX: Trabzon. Karadeniz.',
        'DLM: Dalaman. Güneybatı turizm.',
        'BJV: Milas-Bodrum. Ege turizm.'
      ],
      keyPoints: [
        'IST = İstanbul (yeni)',
        'SAW = Sabiha Gökçen',
        'ESB = Ankara',
        'AYT = Antalya'
      ]
    }
  },
  'CM-M16-U2-L3': {
    lesson_id: 'CM-M16-U2-L3',
    title: 'Dünya Hub\'ları',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Dünya\'nın Önemli Hub\'ları',
      paragraphs: [
        'Avrupa: LHR (Londra), CDG (Paris), FRA (Frankfurt), AMS (Amsterdam), MAD (Madrid)',
        'Körfez: DXB (Dubai), DOH (Doha), AUH (Abu Dhabi), JED (Jeddah)',
        'Asya: SIN (Singapur), HKG (Hong Kong), NRT/HND (Tokyo), ICN (Seul), BKK (Bangkok)',
        'Amerika: ATL (Atlanta), JFK (New York), ORD (Chicago), LAX (Los Angeles), DFW (Dallas)',
        'Dünyanın En Yoğun: 1. ATL, 2. DXB, 3. LHR (uluslararası yolcu)'
      ],
      keyPoints: [
        'ATL = En yoğun',
        'DXB = Körfez lideri',
        'LHR = Avrupa lideri',
        'SIN = Asya hub'
      ]
    }
  },
  'CM-M16-U2-L4': {
    lesson_id: 'CM-M16-U2-L4',
    title: 'Kod Eşleştirme',
    type: 'matching',
    duration: 4,
    xp: 40,
    matching: {
      pairs: [
        { id: 1, left: 'IST', right: 'İstanbul' },
        { id: 2, left: 'DXB', right: 'Dubai' },
        { id: 3, left: 'LHR', right: 'Londra Heathrow' },
        { id: 4, left: 'JFK', right: 'New York' },
        { id: 5, left: 'AYT', right: 'Antalya' },
        { id: 6, left: 'FRA', right: 'Frankfurt' }
      ]
    }
  },

  // ==================== KABİN TERİMLERİ ====================
  'CM-M16-U3-L1': {
    lesson_id: 'CM-M16-U3-L1',
    title: 'Temel Kabin Terimleri',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Kabin Terimleri Sözlüğü',
      paragraphs: [
        'PAX: Passenger. Yolcu sayısı. "120 PAX on board."',
        'POB: Persons On Board. Uçaktaki toplam kişi (yolcu + ekip).',
        'ETA: Estimated Time of Arrival. Tahmini varış saati.',
        'ETD: Estimated Time of Departure. Tahmini kalkış saati.',
        'STA/STD: Scheduled (planlanmış) varış/kalkış.',
        'CREW: Ekip. Cockpit crew (pilot) + Cabin crew (kabin).'
      ],
      keyPoints: [
        'PAX = Yolcu',
        'POB = Toplam kişi',
        'ETA = Varış tahmini',
        'CREW = Ekip'
      ]
    }
  },
  'CM-M16-U3-L2': {
    lesson_id: 'CM-M16-U3-L2',
    title: 'Operasyonel Terimler',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Operasyonel Terimler',
      paragraphs: [
        'BOARDING: Uçağa biniş. "Boarding completed."',
        'DEPARTURE: Kalkış. "Departure delayed."',
        'PUSHBACK: Uçağın geri itilmesi. "Pushback approved."',
        'TAXI: Piste sürüş. "Taxiing to runway."',
        'TAKEOFF: Havalanma. "Takeoff roll."',
        'CRUISE: Seyir. "Cruising at FL350."',
        'DESCENT: Alçalma. "Starting descent."',
        'LANDING: İniş. "Smooth landing."',
        'TURNAROUND: Geri dönüş hazırlığı. İniş-kalkış arası.'
      ],
      keyPoints: [
        'PUSHBACK = Geri itme',
        'TAXI = Piste sürüş',
        'FL = Flight Level',
        'TURNAROUND = Dönüş'
      ]
    }
  },
  'CM-M16-U3-L3': {
    lesson_id: 'CM-M16-U3-L3',
    title: 'Terim Quiz',
    type: 'quiz',
    duration: 5,
    xp: 40,
    quiz: {
      questions: [
        { q: 'PAX ne demek?', options: ['Pilot', 'Yolcu', 'Pazıl', 'Park'], correct: 1 },
        { q: 'ETA ne demek?', options: ['Extra Time', 'Estimated Arrival', 'End Time', 'Early Take'], correct: 1 },
        { q: 'PUSHBACK ne?', options: ['Havalanma', 'Geri itme', 'İniş', 'Seyir'], correct: 1 },
        { q: 'FL350 ne demek?', options: ['350 km', '350 mil', '35,000 feet', '350 knot'], correct: 2 },
        { q: 'TURNAROUND ne?', options: ['Dönüş hazırlığı', 'Uçuş iptali', 'Yolcu değişimi', 'Ekip değişimi'], correct: 0 }
      ]
    }
  },

  // ==================== YOLCU KODLARI ====================
  'CM-M16-U4-L1': {
    lesson_id: 'CM-M16-U4-L1',
    title: 'SSR Kodları',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'SSR - Special Service Request',
      paragraphs: [
        'SSR: Özel hizmet talebi. Rezervasyona eklenir.',
        'WCHC/WCHR/WCHS: Tekerlekli sandalye türleri.',
        'BLND: Görme engelli. DEAF: İşitme engelli.',
        'UMNR: Unaccompanied Minor. Refakatsiz çocuk.',
        'MAAS: Meet and Assist. Karşılama yardımı.',
        'EXST: Extra Seat. Ek koltuk (büyük yolcu için).'
      ],
      keyPoints: [
        'SSR = Özel hizmet',
        'WCHC = Kabin yardımı',
        'UMNR = Refakatsiz çocuk',
        'MAAS = Karşılama'
      ]
    }
  },
  'CM-M16-U4-L2': {
    lesson_id: 'CM-M16-U4-L2',
    title: 'Yemek Kodları (SPML)',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'SPML - Special Meal Kodları',
      paragraphs: [
        'SPML: Special Meal. Özel yemek talebi.',
        'VGML: Strict Vegetarian / Vegan. Hayvansal ürün yok.',
        'VLML: Vegetarian Lacto-Ovo. Süt/yumurta var.',
        'AVML: Asian Vegetarian. Hint baharatlı.',
        'HNML: Hindu Meal. Domuz/sığır yok.',
        'MOML: Muslim Meal. Helal.',
        'KSML: Kosher. Yahudi.',
        'DBML: Diabetic. Diyabet.',
        'GFML: Gluten Free. Glütensiz.',
        'CHML: Child Meal. Çocuk menüsü.',
        'BBML: Baby Meal. Bebek maması.'
      ],
      keyPoints: [
        'VGML = Vegan',
        'MOML = Helal',
        'KSML = Koşer',
        'GFML = Glütensiz'
      ]
    }
  },
  'CM-M16-U4-L3': {
    lesson_id: 'CM-M16-U4-L3',
    title: 'Kod Doğru/Yanlış',
    type: 'truefalse',
    duration: 4,
    xp: 35,
    truefalse: {
      statements: [
        { statement: 'PAX yolcu demektir.', isTrue: true, explanation: 'Doğru! PAX = Passenger.' },
        { statement: 'VGML vejeteryan (sütlü) yemektir.', isTrue: false, explanation: 'Yanlış! VGML = Vegan. VLML = Vejeteryan (sütlü).' },
        { statement: 'IST Sabiha Gökçen kodudur.', isTrue: false, explanation: 'Yanlış! IST = İstanbul Havalimanı. SAW = Sabiha Gökçen.' },
        { statement: 'ETA varış tahmini demektir.', isTrue: true, explanation: 'Doğru! Estimated Time of Arrival.' },
        { statement: 'UMNR engelli yolcu kodudur.', isTrue: false, explanation: 'Yanlış! UMNR = Refakatsiz çocuk.' }
      ]
    }
  },

  // ==================== FİNAL ====================
  'CM-M16-U5-L1': {
    lesson_id: 'CM-M16-U5-L1',
    title: 'Mega Terim Yarışı',
    type: 'timerace',
    duration: 5,
    xp: 60,
    timerace: {
      timePerQuestion: 6,
      questions: [
        { q: 'B harfi fonetik?', options: ['Beta', 'Bravo', 'Boy', 'Baker'], correct: 1 },
        { q: 'İstanbul kodu?', options: ['SAW', 'IST', 'ESB', 'AYT'], correct: 1 },
        { q: 'PAX ne?', options: ['Pilot', 'Yolcu', 'Uçak', 'Pist'], correct: 1 },
        { q: 'Vegan yemek?', options: ['VLML', 'VGML', 'MOML', 'HNML'], correct: 1 },
        { q: 'Dubai kodu?', options: ['DXB', 'DOH', 'AUH', 'DUB'], correct: 0 },
        { q: 'WCHC ne?', options: ['VIP', 'Tekerlekli sandalye', 'Çocuk', 'Yemek'], correct: 1 },
        { q: 'Alpha hangi harf?', options: ['B', 'A', 'C', 'D'], correct: 1 },
        { q: 'Londra kodu?', options: ['LON', 'LHR', 'LDN', 'LND'], correct: 1 }
      ]
    }
  },
  'CM-M16-U5-L2': {
    lesson_id: 'CM-M16-U5-L2',
    title: 'Boşluk Doldur: Terimler',
    type: 'fillin',
    duration: 4,
    xp: 40,
    fillin: {
      sentences: [
        { text: 'A harfinin fonetik karşılığı: ___', answer: 'Alpha' },
        { text: 'İstanbul Havalimanı IATA kodu: ___', answer: 'IST' },
        { text: 'Yolcu kısaltması: ___', answer: 'PAX' },
        { text: 'Tahmini varış saati: ___', answer: 'ETA' },
        { text: 'Helal yemek kodu: ___', answer: 'MOML' }
      ]
    }
  },
  'CM-M16-U5-L3': {
    lesson_id: 'CM-M16-U5-L3',
    title: 'Terimler Final Sınavı',
    type: 'exam',
    duration: 10,
    xp: 80,
    exam: {
      questions: [
        { q: 'N harfi fonetik?', options: ['Nancy', 'November', 'Nine', 'Niner'], correct: 1 },
        { q: 'Ankara havaalani kodu?', options: ['ANK', 'ESB', 'IST', 'AYT'], correct: 1 },
        { q: 'POB ne demek?', options: ['Point of Boarding', 'Persons On Board', 'Pilot On Board', 'Passenger Only'], correct: 1 },
        { q: 'Koşer yemek kodu?', options: ['MOML', 'KSML', 'HNML', 'VGML'], correct: 1 },
        { q: 'MAAS ne?', options: ['Meal', 'Meet and Assist', 'Medical', 'Minor'], correct: 1 },
        { q: 'Zulu hangi harf?', options: ['X', 'Y', 'Z', 'W'], correct: 2 },
        { q: 'Pegasus hub kodu?', options: ['IST', 'SAW', 'ESB', 'AYT'], correct: 1 },
        { q: 'PUSHBACK ne?', options: ['Kalkış', 'Geri itme', 'İniş', 'Seyir'], correct: 1 },
        { q: 'FL350 kaç feet?', options: ['350', '3,500', '35,000', '350,000'], correct: 2 },
        { q: 'UMNR ne?', options: ['VIP', 'Engelli', 'Refakatsiz çocuk', 'Yaşlı'], correct: 2 }
      ]
    }
  }
};

export default cabinCrewContentsM16;
